/**
 * @fileoverview Authentication and User Profile API Module
 * This module provides authentication functionality and user profile management including:
 * - Single Sign-On (SSO) authentication via Azure Active Directory
 * - OAuth token validation and processing
 * - Microsoft Graph API integration for user profile photos
 * - Server address configuration for different environments
 */

import axios from "axios";

/**
 * Server address configuration based on environment
 * Determines the correct server URL for API calls based on current origin
 * @type {string}
 */
export const serverAddress =
  process.env?.REACT_APP_BASE_URL || "http://localhost:3000/ui";

export const loginApi = async (data) => {
  const url = `${serverAddress}/oauth/auth/login/postSSOValidation`;
  const body = {
    emailId: data.emailId,
    adoAccessToken: data.adoAccessToken,
    applicationId: 2,
  };
  try {
    const response = await axios.post(url, body);
    return {
      status: response.status,
      data: {
        ...response.data,
        primaryRoleId: null,
        primaryRoleName: null,
        roles: [],
      },
    };
  } catch (error) {
    if (error.response) {
      // Return the error response with status and data
      return {
        status: error.response.status,
        data: error.response.data,
      };
    }
    return {
      status: 500,
      data: {
        success: false,
        message: `loginApi failed: ${error.message}`,
        errors: [],
      },
    };
  }
};
export const getProfilePhoto = async (accessToken) => {
  try {
    const response = await fetch(
      "https://graph.microsoft.com/v1.0/me/photo/$value",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    if (response.status === 404) {
      return "";
    }

    if (!response.ok) {
      return "Failed to fetch profile photo";
    }

    const blob = await response.blob();

    if (blob.size === 0) {
      return "";
    }

    return URL.createObjectURL(blob);
  } catch (error) {
    return `getProfilePhoto failed: ${error.message}`;
  }
};
